import {useState} from "react";
import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";
import DashboardNavbar from "./dashboard/DashboardNavbar";
import DashboardSidebar from "./dashboard/DashboardSidebar";

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(220);

  const onCloseSidebar = () => {
    if (drawerWidth === 55) {
      setDrawerWidth(220);
    } else {
      setDrawerWidth(55);
    }
  };

  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{display: "flex", overflow: "visible"}}>
      <DashboardNavbar onOpenSidebar={handleClose} drawerWidth={drawerWidth} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={onCloseSidebar}
        drawerWidth={drawerWidth}
        handleClose={handleClose}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 8,
          pb: 3,
          px: {xs: 3, sm: 5},
          width: "calc(100% - " + drawerWidth + "px)",
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
